import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useSearchParams } from 'react-router-dom';
import Login from './components/auth/Login';
import Sidebar2 from './components/Sidebar2';
import TrashFile from './components/trash/TrashFile';
import axios from 'axios';
import Header from './components/Header';
import Main from './components/Main';
import Quotation from './components/quotation/Quotation';
import CreateQuotation from './components/quotation/CreateQuot';
import Profile from './components/Profile';
import QuotationViews from './components/quotation/QuotationView';
import DailyMetalFix from './components/Static/dailyMetalFix';
import WaxtoMetalConversion from './components/Static/WaxtoMetalConversion';
import CastingCharge from './components/Static/CastingCharges';
import OffersList from './components/Offers';
import GroupList from './components/Groups';
import PasswordReset from './components/auth/PasswordReset';
import PasswordResetSuccess from './components/auth/PasswordResetSuccess';
import PasswordVerification from './components/auth/PasswordVerication';
import Branchs from './components/branchs/Branchs';
import CreateBranch from './components/branchs/CreateBranch';
import Groups from './components/groups/Groups';
import CreateGroup from './components/groups/CreateGroup';
import Objects from './components/object/Objects';
import CreateObject from './components/object/CreateObject';
import TransactionsList from './components/TransactionsList';
import Company from './components/company/Company';
import Users from './components/users/Users';
import CreateUser from './components/users/CreateUsers';
import Customers from './components/customer/Customers';
import CreateCustomer from './components/customer/CreateCustomers';
import Metal from './components/metal/Metal';
import CreateMetal from './components/metal/CreateMetal';
import Material from './components/materials/Material';
import CreateMaterial from './components/materials/CreateMaterial';
import MyStlBussinessLibrary from './components/bussiness-library/MystlBussinessLibrary';
import CustomerFilter from './components/customer-files-filter/CustomersFilter';
import ViewCustomer from './components/customer/ViewCustomer';
import ChangePassword from './components/ChangePassword';
import Invoices from './components/invoices/Invoices';
import Orders from './components/orders/Orders';
import CreateOrder from './components/orders/CreateOrder';
import Jobs from './components/jobs/Jobs';
import Products from './components/products/Products';
import CreateProduct from './components/products/CreateProduct';
import QRJobViews from './components/qrjobviews/QRJobView';
import QROrderViews from './components/qrorderviews/QROrderView';
import CreateInvoice from './components/invoices/CreateInvoice';
import XeroAuth from './components/XeroAuth';
import QRJobViews2 from './components/qrjobviews2/QRJobView2';
import LiveFeed from './components/jobs/LiveFeed';
import CreateJob from './components/jobs/CreateJob';
import OptionJobCategory from './components/option-job-category/OptionJobCategory';
import CreateOptionJobCategory from './components/option-job-category/CreateOptionJobCategory';
import OptionJobValue from './components/option-job-value/OptionJobValue';
import CreateOptionJobValue from './components/option-job-value/CreateOptionJobValue';
import JobsList from './components/jobs/JobsList';
import ScanPointDesk from './components/jobs/ScanPointDesk';
import JobsPrintFolder from './components/jobs/JobsPrintFolder';
import ManualInvoiceCreate from "./components/invoices/ManualInvoiceCreate";
import ManualInvoice from "./components/invoices/ManualInvoice";
import QRJobViewOnlyJob from './components/jobs/ScanPointPhone';
import OrderQrView from './components/jobs/OrderQrView';
import OrdersHistory from './components/orders history/OrdersHistory';
import Collective from './components/collectivepage/Collective';
import ApiMetalPrice from './components/Static/ApiMetalPrice';
import JobsHistoryList from './components/jobs/JobsHistory';
import QuotationHistory from './components/quotation history/QuotationHistory';
import MetalsPriceApi from './components/MetalsPriceApi';
import CollectiveGroup from './components/collectivegroup/CollectiveGroup';
import CreateCollectiveGroup from './components/collectivegroup/CreateCollectiveGroup';
import CollectiveQRForm from './components/collectivepage/CollectiveQRForm';
import MyStlMouldLibrary from './components/mould-library/MystlMouldLibrary';
import MyStlMouldAuth from './components/mould-authorization/MystlMouldAuth';
import WaxMouldFolder from './components/jobs/WaxPrintFolder';
import WaxMouldFolderHistory from './components/wax-history/WaxMouldFolderHistory';

// Dark Mode
const darkModeEnabled = localStorage.getItem('DarkMode');
if (darkModeEnabled) {
  const htmlElement = document.querySelector('html');
  htmlElement.setAttribute('data-layout-mode', 'light');
}

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const username = JSON.parse(localStorage.getItem('yourName'));
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    setUserRole(JSON.parse(localStorage.getItem('yourRole')));
    if (userData) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  useEffect(() => {
    const storedPermissions = sessionStorage.getItem('userPermissions');
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('userData');
    localStorage.removeItem('yourName');
    localStorage.removeItem('yourRole');
    setIsLoggedIn(false);
  };

  useEffect(() => {
    const axiosInterceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          logout();
          return Promise.reject(error);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(axiosInterceptor);
    };
  }, []);

  const QRJobViews2Wrapper = () => {
    const [searchParams] = useSearchParams();

    // Verify if the parameters exist
    const trs = searchParams.get('trs');
    const qr = searchParams.get('qr');

    if (!trs && !qr) {
      // If there are no valid parameters, redirect to the main page
      return <Navigate to="/main-panel" />;
    }

    return <OrderQrView trs={trs} qr={qr} />;
  };

  const QRCollectiveViewsWrapper = () => {
    const [searchParams] = useSearchParams();

    // Verify if the parameters exist
    const group = searchParams.get('group');

    if (!group) {
      // If there are no valid parameters, redirect to the main page
      return <Navigate to="/main-panel" />;
    }

    return <CollectiveQRForm group={group} />;
  };

  const QRJobViews1Wrapper = () => {
    const [searchParams] = useSearchParams();

    // Verify if the parameters exist
    const qr = searchParams.get('qr');

    if (!qr) {
      // If there are no valid parameters, redirect to the main page
      return <Navigate to="/main-panel" />;
    }

    return <QRJobViewOnlyJob qr={qr} />;
  };

  const AuthenticatedRoutes = () => (
    <Routes>

      <Route path='/trash' element={<TrashFile />} />

      <Route path='/main-panel' element={<Main username={username} userRole={userRole} />} />
      <Route path='/quotation' element={<Quotation />} />
      <Route path='/quotations-history' element={<QuotationHistory />} />
      <Route path='/quotation-views' element={<QuotationViews />} />
      <Route path='/create-quotation' element={<CreateQuotation username={username} />} />
      <Route path='/orders' element={<Orders />} />
      <Route path='/collective-jobs' element={<Collective />} />
      <Route path='/create-order' element={< CreateOrder />} />

      <Route path='/order-history' element={<OrdersHistory />} />
      <Route path='/job-history' element={<JobsHistoryList username={username} />} />

      <Route path='/orders/qr' element={<QRJobViews />} />
      <Route path='/orders/qr2' element={<QRJobViews2 />} />

      <Route path='/jobs/collective/qr-group' element={<QRCollectiveViewsWrapper />} />

      <Route path='/orders/qr-group' element={<QRJobViews2Wrapper />} />
      <Route path='/jobs/qr-single-job' element={<QRJobViews1Wrapper />} />

      <Route path='/option-job-category' element={<OptionJobCategory />} />
      <Route path='/option-job-category-create' element={<CreateOptionJobCategory />} />
      <Route path='/option-job-value' element={<OptionJobValue />} />
      <Route path='/option-job-value-create' element={<CreateOptionJobValue />} />

      <Route path='/jobs' element={<Jobs />} />
      <Route path='/job-live-feed' element={<LiveFeed />} />
      <Route path='/jobs-list' element={<JobsList />} />
      <Route path='/jobs-create' element={<CreateJob username={username} />} />
      <Route path='/jobs-print-folder' element={<JobsPrintFolder isRepriting={false} />} />
      <Route path='/jobs-reprint-folder' element={<JobsPrintFolder isRepriting={true} />} />
      <Route path='/wax-folder' element={<WaxMouldFolder isRepriting={false} />} />
      <Route path='/wax-history' element={<WaxMouldFolderHistory isRepriting={false} />} />

      <Route path='/scan-point' element={<ScanPointDesk />} />

      <Route path='/invoice-list' element={<ManualInvoice />} />
      <Route path='/create-invoice-from-customer' element={<ManualInvoiceCreate isOrder={false} />} />
      <Route path='/create-invoice-from-order' element={<ManualInvoiceCreate isOrder={true} />} /
      >
      <Route path='/customers-filter' element={<CustomerFilter username={username} />} />

      <Route path='/bussiness-library' element={<MyStlBussinessLibrary username={username} />} />
      <Route path='/mould-folders' element={<MyStlMouldLibrary username={username} />} />
      <Route path='/mould-auth' element={<MyStlMouldAuth username={username} />} />
      <Route path='/product-list' element={<Products />} />
      <Route path='/create-product' element={<CreateProduct />} />
      <Route path='/offers-list' element={<OffersList />} />
      {/*       {hasAccess(10) && <Route path='/users' element={<UserModule />} />}
      {hasAccess(10) && <Route path='/add-users' element={<AddUser />} />} */}
      <Route path='/group-list' element={<GroupList />} />
      <Route path='/casting-charges' element={<CastingCharge />} />
      <Route path='/daily-metal-fix' element={<DailyMetalFix />} />
      <Route path='/api-metal-price' element={<ApiMetalPrice />} />
      <Route path='/metals-price-api' element={<MetalsPriceApi />} />
      <Route path='/wax-to-metal-conversion' element={<WaxtoMetalConversion />} />
      <Route path='/profiles' element={<Profile username={username} userRole={userRole} />} />

      <Route path='/branchs' element={<Branchs username={username} />} />
      <Route path='/create-branch' element={<CreateBranch username={username} />} />

      <Route path='/groups' element={<Groups username={username} />} />
      <Route path='/create-group' element={<CreateGroup username={username} />} />

      <Route path='/objects' element={<Objects username={username} />} />
      <Route path='/create-object' element={<CreateObject username={username} />} />

      <Route path='/company/list' element={<Company username={username} />} />
      <Route path='/create-object' element={<CreateObject username={username} />} />

      <Route path='/users/list' element={<Users username={username} />} />
      <Route path='/create-user' element={<CreateUser username={username} />} />

      <Route path='/customers' element={<Customers username={username} />} />
      <Route path='/create-customer' element={<CreateCustomer username={username} />} />
      <Route path='/views-customer' element={<ViewCustomer username={username} />} />

      <Route path='/metal-types' element={<Metal username={username} />} />
      <Route path='/create-metal-types' element={<CreateMetal username={username} />} />

      <Route path='/collective-groups' element={<CollectiveGroup username={username} />} />
      <Route path='/create-collective-group' element={<CreateCollectiveGroup username={username} />} />

      <Route path='/materials' element={<Material username={username} />} />
      <Route path='/create-material' element={<CreateMaterial username={username} />} />

      <Route path='/transactions-status' element={<TransactionsList />} />

      <Route path='/xero-autenticator' element={<XeroAuth username={username} />} />

      <Route path='/change-password' element={<ChangePassword />} />

      <Route path="*" element={<Navigate to="/main-panel" />} />
    </Routes>
  );

  const UnauthenticatedRoutes = () => (
    <Routes>
      {!isLoggedIn && (
        <>
          <Route path='/login' element={<Login />} />
          <Route path='/password-reset' element={<PasswordReset />} />
          <Route path='/password-recover-success' element={<PasswordResetSuccess />} />
          <Route path='/password_recover' element={<PasswordVerification />} />
          {/*  <Route path='/password_reset' element={<PasswordResetSuccess />} /> */}
          {/*  {isLoggedIn === true ? (<Route path="*" element={<Navigate to="/login" />} />) : (console.log("entro aqui")) } */}
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      )}
      {/*   <Route path='/orders/qr2' element={<QRJobViews2 />} /> */}

    </Routes>
  );

  return (
    <Router>
      <div>
        {isLoggedIn ? (
          <div id='layout-wrapper'>
            <Header logout={logout} username={username} userRole={userRole} />
            <Sidebar2 username={username} userRole={userRole} permissions={permissions} />
            <div className="main-content">
              <AuthenticatedRoutes />
            </div>
          </div>
        ) : (

          <UnauthenticatedRoutes />

        )}
      </div>
    </Router>
  );
};

export default App;
